import React from 'react';
const SiteContext = React.createContext();
export default SiteContext;
